import { atom } from "jotai"

// export const loadingAtom = atom(false);
export const loadingSaleAtom = atom(false)
